import { Controller } from "@hotwired/stimulus"

const MOBILE_BREAKPOINT = 640
const ACTION_CLEARANCE_GAP = 8

export default class extends Controller {
  keepFocusedFieldVisible(event) {
    const field = event.target?.closest("input, select, textarea")
    if (!field || field.disabled || field.type === "hidden") return

    this.keepElementAboveActions(field)
  }

  keepNextFieldsVisible() {
    const dateField = this.element.querySelector("#preparation_date_cooked")
    if (dateField) this.keepElementAboveActions(dateField)
  }

  keepElementAboveActions(element) {
    if (!this.isMobile() || !element) return

    const adjust = () => {
      const actions = this.element.querySelector(".ec-form-page-sticky-actions")
      if (!actions || actions.hidden) return

      const actionsRect = actions.getBoundingClientRect()
      if (actionsRect.top >= window.innerHeight || actionsRect.bottom <= 0) return

      const targetBottom = this.describedContentBottom(element)
      const safeBottom = actionsRect.top - ACTION_CLEARANCE_GAP
      const scrollDelta = targetBottom - safeBottom
      if (scrollDelta > 0) window.scrollBy(0, scrollDelta)
    }

    adjust()
    window.requestAnimationFrame(adjust)
  }

  describedContentBottom(element) {
    const describedBy = (element.getAttribute("aria-describedby") || "")
      .split(/\s+/)
      .filter(Boolean)

    return [ element, ...describedBy.map((id) => document.getElementById(id)) ]
      .filter((candidate) => candidate && !candidate.hidden)
      .reduce((bottom, candidate) => Math.max(bottom, candidate.getBoundingClientRect().bottom), 0)
  }

  isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT
  }
}
